import { initReactI18next } from "react-i18next";
import translations_de from "./public/static/locales/de/translations.json";
import i18n from "i18next";
export const FALLBACK_LANGUAGE = "de";
const resources = {
    de: {
        translations: translations_de,
    },
};
i18n.use(initReactI18next).init({
    resources,
    lng: "de",
    keySeparator: false,
    nsSeparator: ":",
    interpolation: { escapeValue: false },
    defaultNS: "translations",
    ns: ["translations"],
    initImmediate: false, // important: otherwise init is deferred!
    debug: true,
});
export default i18n;
